'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../_virtual/_rollupPluginBabelHelpers.js');
var styles = require('@material-ui/styles');

var useStyles = styles.makeStyles(theme => ({
  editor: {
    overflow: 'hidden',
    position: 'relative',
    border: props => !props.readOnly ? "1px solid ".concat(theme.palette.divider) : 'none',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.default,
    outline: 'none'
  },
  isFocused: {},
  buttons: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexWrap: 'nowrap',
    borderTop: "1px solid ".concat(theme.palette.divider),
    borderTopWidth: 1,
    borderTopStyle: 'solid',
    borderTopColor: 'rgba(0, 0, 0, 0)',
    padding: 4,
    backgroundColor: theme.palette.background.default,
    transition: theme.transitions.create(['background-color', 'border-top-color']),
    '&$isFocused': {
      backgroundColor: theme.palette.grey[100],
      borderTopColor: theme.palette.divider,
      '& $actionButton': {
        opacity: 1
      }
    }
  },
  actionButton: {
    opacity: 0.5,
    marginRight: 4,
    transition: theme.transitions.create('opacity')
  },
  actionButtonIcon: {},
  content: _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({
    padding: 8,
    outline: 'none'
  }, theme.typography.body2), {}, {
    '& p': {
      marginBlockStart: 0,
      marginBlockEnd: 0
    }
  }),
  button: {
    margin: 2
  },
  element: {
    // ...theme.typography.body2,
    fontSize: theme.typography.body2.fontSize,
    marginBlockStart: 0,
    marginBlockEnd: 0
  },
  heading: {
    marginBlockStart: "".concat(theme.spacing(0.5), "px"),
    marginBlockEnd: "".concat(theme.spacing(0.5), "px"),
    '& span': {
      fontSize: theme.typography.h6.fontSize
    }
  },
  quote: {
    position: 'relative',
    marginLeft: 0,
    marginRight: 0,
    paddingLeft: theme.spacing(2),
    color: theme.palette.text.secondary,
    borderLeft: "2px solid ".concat(theme.palette.divider),
    '& span': {
      fontSize: theme.typography.body2.fontSize,
      fontFamily: '"Vollkorn", serif'
    }
  },
  leaf: {
    fontSize: theme.typography.body2.fontSize,
    '& strong': {
      fontWeight: 500
    }
  }
}));
var useMessageStyles = styles.makeStyles(theme => ({
  message: _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({
    padding: 8,
    outline: 'none',
    overflow: 'auto',
    position: 'relative',
    minHeight: props => {
      var _props$minHeight;

      return (_props$minHeight = props.minHeight) !== null && _props$minHeight !== void 0 ? _props$minHeight : 'unset';
    },
    maxHeight: props => {
      var _props$maxHeight;

      return (_props$maxHeight = props.maxHeight) !== null && _props$maxHeight !== void 0 ? _props$maxHeight : 'unset';
    }
  }, theme.typography.body2), {}, {
    '& p': {
      marginBlockStart: 0,
      marginBlockEnd: 0
    },
    '& blockquote': {
      position: 'relative',
      marginLeft: 0,
      marginRight: 0,
      paddingLeft: theme.spacing(2),
      color: theme.palette.text.secondary,
      borderLeft: "2px solid ".concat(theme.palette.divider),
      '& span': {
        fontSize: theme.typography.body2.fontSize,
        fontFamily: 'serif'
      }
    },
    '& strong': {
      fontWeight: 700
    },
    '& h1': {}
  })
}));

exports.useMessageStyles = useMessageStyles;
exports.useStyles = useStyles;
